import { Box, Button, ButtonProps, Center, Container, Text, Heading, Tab, TabList, TabPanel, TabPanels, Tabs, useDisclosure, Flex, Spacer } from "@chakra-ui/react";
import { ReactElement, useEffect, useState } from "react";
import LogosTable from "../../components/table";
import Layout from "../layouts";
import { useNavigate } from "react-router-dom";
import LogosTablePagination from "../../components/table/table-pagination";
import { usePaginator } from "chakra-paginator";
import LogosTableSearch from "../../components/table/table-search";
import VoucherService from "../../services/vouchers/voucher-service";
import LoadingScreen from "../../components/loading-screen";
import Number from "components/number-format";
import moment from "moment";

const VoucherScene = (): ReactElement => {
    const navigate = useNavigate();
    const [vouchers, setVouchers] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [totalVoucher, setTotalVoucher] = useState<number>(0);
    const [searchKey, setSearchKey] = useState<string>("");

    const {
        pagesQuantity,
        currentPage,
        setCurrentPage,
        pageSize,
        setPageSize,
        offset
    } = usePaginator({
        total: totalVoucher,
        initialState: {
            pageSize: 20,
            currentPage: 1
        }
    });

    useEffect(() => {
        setIsLoading(true);
        let skipCount = ((currentPage - 1) * pageSize);

        VoucherService.GetListVoucher(searchKey, skipCount, pageSize).then((res: any) => {
            if (res.result) {
                setVouchers(res.result.items);
                setTotalVoucher(res.result.totalCount);
            }
        }).finally(() => {
            setIsLoading(false);
        });
    }, [currentPage]);

    const handleClickRow = (voucher: any) => {
        navigate(`/vouchers/${voucher.id}`);
    };

    const handlePageChange = (nextPage: number) => {
        setCurrentPage(nextPage);
    };

    const handleSearch = (searchKey: string) => {
        //setIsLoading(true);
        let skipCount = ((currentPage - 1) * pageSize);

        VoucherService.GetListVoucher(searchKey, skipCount, pageSize).then((res: any) => {
            if (res.result) {
                setVouchers(res.result.items);
                setTotalVoucher(res.result.totalCount);
            }
        }).finally(() => {
            //setIsLoading(false);
        });
    };
    if (isLoading)
        return <LoadingScreen />;

    return (
        <Layout>
            <Container maxWidth={"8xl"} mt={2} mb={5}>
                <Box>
                    <Heading fontSize={'3xl'} fontWeight={"extrabold"}>Vouchers</Heading>
                </Box>
                <Flex mt={3}>
                    <Button onClick={() => navigate('/vouchers/new')}>Buat Voucher Baru</Button>
                </Flex>
                <Box mt={6}>
                    <LogosTableSearch handleSearch={handleSearch} />
                    <LogosTable
                        headers={[
                            { label: 'Nama' },
                            { label: 'Kode Voucher' },
                            { label: 'Discount' },
                            { label: 'Program' },
                            { label: 'Kadarluasa' },
                            { label: 'Status' }]}
                        rows={[
                            { propertyName: 'name', baseUrl: '/vouchers/' },
                            { propertyName: 'voucherCode', baseUrl: '/vouchers/' },
                            {
                                render: (item: any) => {
                                    if (item.isPercentage)
                                        return <Text fontWeight={'bold'}>{(item.value * 100).toFixed(0)}%</Text>
                                    return <Text fontWeight={'bold'}><Number value={item.value} prefix={'Rp '} /></Text>
                                }
                            },
                            { render: (item: any) => { return <Text>{item.isForAllProgram ? "Semua Program" : item.program.name}</Text> } },
                            { render: (item: any) => { return <Text>{item.isCanExpire ? moment(item.expiryDate).format("DD MMMM yyyy HH:mm") : "Tidak Kadarluasa"}</Text> } },
                            { render: (item: any) => { return <Text fontWeight={'bold'} color={item.isActive ? "green.600" : "red.500"}>{item.isActive ? "Aktif" : "Tidak Aktif"}</Text> } }
                        ]}
                        data={vouchers}
                        onRowClick={handleClickRow}
                    />
                    <LogosTablePagination currentPage={currentPage} pagesQuantity={pagesQuantity} handlePageChange={handlePageChange} />
                </Box>
            </Container>
        </Layout >
    );
};

export default VoucherScene;